import * as types from '../actions/actionTypes'
import { stringifyQueryString, takeQueryParams } from '../libs/historyHelper'

export const FETCH_LANDING_STATES = {
  INIT: 0,
  FETCHED_IS_SELLER: 1,
  FETCHED_IS_NOVICE: 2,
  ERROR: 3,
  IS_BUYER: 4,
}

export const DASHBOARD_PARAMS = {
  TAB: 'tab',
  TYPE: 'type',
  TAB_SELLER_HISTORY: '1',
  TAB_SLASH: '2',
  TYPE_INFLOW: 'inflow',
  TYPE_OUTFLOW: 'outflow',
}

export const initialState = {
  fetchLandingState: FETCH_LANDING_STATES.INIT,
  dashboardSearchParams: stringifyQueryString(
    takeQueryParams([DASHBOARD_PARAMS.TAB, DASHBOARD_PARAMS.TYPE]),
  ),
  isActive: true,
  unavailable: false, // slash 1.3
}

export function shouldFetchLandingSelector(landing) {
  return landing.fetchLandingState === FETCH_LANDING_STATES.INIT
}

export default function landingReducer(landing = initialState, action) {
  switch (action.type) {
    case types.SET_LANDING_FETCH_STATE:
      return {
        ...landing,
        fetchLandingState: action.payload || FETCH_LANDING_STATES.INIT,
      }
    case types.SET_DASHBOARD_SEARCH_PARAMS:
      return {
        ...landing,
        dashboardSearchParams: action.payload || null,
      }
    case types.GET_SLASH_INFO_SUCCESS:
    case types.GET_ITEM_ENTRY_INFO_SUCCESS:
    case types.GET_BUYER_INSTALMENTS_INFO_SUCCESS:
    case types.GET_BUYER_PERIODIC_INFO_SUCCESS:
      return {
        ...landing,
        isActive: action?.payload?.is_active ?? true,
      }
    case types.SET_SLASH_ACTIVE:
      return {
        ...landing,
        isActive: action.payload ?? true,
      }
    case types.SET_ITEM_UNAVAILABLE:
      return {
        ...landing,
        unavailable: true,
      }
    default:
      return landing
  }
}
